import { BASE_API_URL, COOKIE_TIMEOUT } from '../config';
import Web3 from 'web3';
import Cookies from 'js-cookie';

export const loginWithWallet = async (chainId, account) => {
	// const registered = await checkIfUserRegistered(accounts[0]);
	// Request nonce from backend
	const token = Cookies.get('nusic_nft_token');
	// console.log("=====", token);
	if(token !== undefined) {
		const res = await checkJwToken(token, account);
		// console.log('res', res);
		if(res) return token;
	}
	if(chainId === undefined || account === undefined) return;

	const responseNonce = await (await fetch(BASE_API_URL + `/wallet/${chainId}/${account}/nonce`, {method: 'get'})).json();
	const nonce = responseNonce.nonce;

	// Sign message
	const signedMessage = await handleSignMessage(account, nonce);
	// Send signature to backend
	const responseSign = await(await fetch(BASE_API_URL + `/wallet/${chainId}/${account}/signature`, {
		method: "post",
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(signedMessage)
	})).json();
	console.log('responseSign', responseSign)
	Cookies.set('nusic_nft_token', responseSign.token, {expires: 1/24/60 * COOKIE_TIMEOUT})
	return responseSign.token;
}

const handleSignMessage = (publicAddress, nonce) => {
	// Define instance of web3
	var web3 = new Web3(window.ethereum)
	return new Promise((resolve, reject) => {
		web3.eth.personal.sign(
			web3.utils.fromUtf8(`Nonce: ${nonce}`),
			publicAddress,
			(err, signature) => {
				if (err) return reject(err);
				return resolve({ publicAddress, signature });
			}
		)}
	);
}

/**
 * Check the jwtToken is available for login and opertation
 */
export const checkJwToken = async (token, currentAccount) => {
	try {
		const res = await(await fetch(BASE_API_URL + `/wallet/profile`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': token,
			}
		})).json();
		if(res.success && res.user.address.toLowerCase() === currentAccount.toLowerCase()) return true;
		else return false;	
	} catch(err) {
		console.log(err);
		if(err.status === 401 && err.statusText === "Unauthorized") {
			return false;
		}
	}
}